import axios from "axios";

const API_BASE_URL = "https://www.ezcoupons.com"; // import.meta.env.MODE === "development" ? "https://www.ezcoupons.com" : "localhost";

export const fetchFeed = (state = "UT", countyId = "25", category, limit=9) => {
    return axios.get(API_BASE_URL + `/api/getCategories.php?state=${state}&countyId=${countyId}&category=${category}&limit=${limit}`);
};

export const fetchCompany = (companyID: string) => {
    return axios.get(API_BASE_URL + `/api/getByCompany.php?companyID=${companyID}`);
};

export const fetchCategory = (categoryID: string) => {
    // getByCategory.php does LIKE prefix matching on Info.Category, which
    // stores short codes. Strip trailing zeros so '120000' becomes '12'
    // (matches all restaurants). Subcategory IDs like '120302' stay intact.
    const categoryCode = categoryID.replace(/0+$/, '') || categoryID;
    return axios.get(API_BASE_URL + `/api/getByCategory.php?category=${categoryCode}`);
};

export const fetchSearch = (query: string) => {
    return axios.get(API_BASE_URL + `/api/getByQuery.php?query=${query}`);
};

export const fetchByNames = (names: string[], city: string) => {
    const params = new URLSearchParams();

    names.forEach(name => params.append("names[]", name));
    return axios.get(API_BASE_URL + `/api/getByName.php?names=${params.toString()}`);
};